import { InvoiceStatus } from 'generated/graphql';

export const renderInvoiceStatus = (status: InvoiceStatus) =>
  ({
    [InvoiceStatus.Draft]: 'Draft',
    [InvoiceStatus.Sent]: 'Sent',
    [InvoiceStatus.Paid]: 'Paid',
    [InvoiceStatus.Voided]: 'Voided',
  }[status]);
